<template>
  <Error :code=code :message=message>
    <template slot="actions">
      <v-btn color="secondary" class="black--text" @click="back">
        <v-icon left>mdi-arrow-left</v-icon> Back
      </v-btn>
    </template>
    <p class="subheading font-weight-regular">
      What you’re looking for may have been misplaced elsewhere.
    </p>
  </Error>
</template>

<script>
import Error from './Error'

export default {
  name: 'Error404',
  components: {
    Error
  },

  data: () => ({
    code: 404,
    message: 'Sorry! Page not found.'
  }),

  methods: {
    back() {
      this.$router.back();
    }
  },
}
</script>